import { render, staticRenderFns } from "./BankAccountUpsertProvider.vue?vue&type=template&id=6561e6e1&scoped=true&"
import script from "./BankAccountUpsertProvider.vue?vue&type=script&lang=ts&"
export * from "./BankAccountUpsertProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6561e6e1",
  null
  
)

export default component.exports